// extracted by mini-css-extract-plugin
export default {"wrap":"StudentTrainingsStep_wrap__tfND-"};